module.exports = __webpack_public_path__ + "assets/img/1423.8bea96a9.svg";